
<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('agri_portal.about_service_portal') + ' ' + $t('globalTrans.list')  }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              <i class="fas fa-plus"></i>{{ $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(about)="data">
                      <p v-if="$i18n.locale === 'en'" v-html="data.item.description.length > 500 ? (shortString(data.item.description, 500) + '...') : data.item.description"></p>
                      <p v-else v-html="data.item.description_bn.length > 500 ? (shortString(data.item.description_bn, 500) + '...') : data.item.description_bn"></p>
                    </template>
                    <template v-slot:cell(status)="data">
                      {{ data.item.status ? $t('globalTrans.active') : $t('globalTrans.inactive') }}
                    </template>
                    <template v-slot:cell(action)="data">
                        <a href="javascript:" class="btn_table_action table_action_edit" v-b-modal.modal-4 @click="edit(data.item)"><i class="ri-ball-pen-fill"></i></a>
                        <a href="javascript:" class="btn_table_action table_action_status" v-if="data.item.status === 0" @click="remove(data.item)"><i class="fas fa-toggle-on"></i></a>
                        <a href="javascript:" class="btn_table_action table_action_toggle" v-if="data.item.status === 1" @click="remove(data.item)"><i class="fas fa-toggle-off"></i></a>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :id="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import Form from './Form'
import RestApi, { commonServiceBaseUrl } from '@/config/api_config'
import { aboutPortalListApi, aboutPortalToggleStatusApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import Common from '@/mixins/common'

export default {
  mixins: [ModalBaseMasterList, Common],
  components: {
    Form
  },
  data () {
    return {}
  },
  computed: {
    formTitle () {
       return (this.editItemId === 0) ? `${this.$t('agri_portal.about_service_portal')} ${this.$t('globalTrans.entry')}` : `${this.$t('agri_portal.about_service_portal')} ${this.$t('globalTrans.modify')}`
    },
    columns () {
      const labels = [
        { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
        { label: this.$t('globalTrans.description'), class: 'text-left' },
        { label: this.$t('globalTrans.status'), class: 'text-center' },
        { label: this.$t('globalTrans.action'), class: 'text-center w-10' }
      ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'about' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'about' },
          { key: 'status' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    core.index()
  },
  methods: {
    shortString (str, n) {
        return (str.length > n) ? str.substr(0, n - 1) + '...' : str
    },
    remove (item) {
      this.changeStatus(commonServiceBaseUrl, aboutPortalToggleStatusApi, item)
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = null
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(commonServiceBaseUrl, aboutPortalListApi, params).then(response => {
        if (response.success) {
          this.$store.dispatch('setList', response.data)
        }
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    }
  }
}
</script>
